import React, { useState,useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

import useStyles from "./styles";
import { withSnackbar } from "./../../../../components/Message/Alert";
import { InputBaseField } from '../../../../components/InputField/InputField';
import { formateMdnNumber, validatePhoneNumber, handleNumberKeyPress } from '../../../../components/Common/Extensions';
import { PostDataAPI } from '../../../../Services/APIService';
import DialogLoader from '../../../../components/Loader/DialogLoader';
import { DraggableComponent, Label } from '../../../../components/UiElements/UiElements';

function ChangeVMPassword({ dialogOpenClose, handleClose, handleSuccessClose, fromDashboard, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [accountNumber, setAccountNumber] = useState(props.accountNumber);
    const [emailAddress, setEmailAddress] = useState(props.emailAddress);
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({ newICC: '', mdnNumber: formateMdnNumber(props.mdnNumber) });
    const [errorMessages, setErrorMessages] = useState({
        errorICCNumber: false, errorICCNumberLength: false
    })
    const passwordPattern = /^[+\-]?[0-9]+$/;

    const handlePhoneChange = e => {
        const { name, value } = e.target;
        if (e.nativeEvent.data != "e") {

            if (e.nativeEvent.data != null || e.target.value != "") {
                // for fomatting
                const re = /^[0-9\b]+$/;
                e.target.value = e.target.value.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');
                const { name, value } = e.target;
                if ((e.target.value === '' || re.test(e.target.value))) {

                    var cleaned = ('' + e.target.value).replace(/\D/g, '')
                    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
                    if (match) {
                        var intlCode = (match[1] ? '+1 ' : ''),
                            number = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');

                        setState(prevState => ({
                            ...prevState,
                            [name]: number
                        }));
                        return;
                    }
                    setState(prevState => ({
                        ...prevState,
                        [name]: value
                    }));
                }
                else {
                    if (!re.test(e.target.value)) {
                        e.preventDefault();
                    }

                }
            }
            else {
                setState(prevState => ({
                    ...prevState,
                    [name]: value
                }));

                if (e.target.value != "") {

                    setErrorMessages(prevState => ({
                        ...prevState,
                        errorPhoneLength: true
                    }));
                }

            }
        }
        else
            e.preventDefault();
    }


    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const changeVMPassword = () => {
        let errorList = [];

        if (!state.mdnNumber) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: false
            }));
        }
        if (state.mdnNumber && !validatePhoneNumber(state.mdnNumber)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidPhone: false
            }));
        }
        if (!state.newPassword) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorNewPassword: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorNewPassword: false
            }));
        }

        if (!passwordPattern.test(state.newPassword)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidNewPassword: true
            }));
            errorList.push(true);
        } else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidNewPassword: false
            }));
        }

        
        if (errorList.length < 1) {
            var obj = {
                MDN: state.mdnNumber,
                newPassword: state.newPassword,
                referenceNumber: accountNumber + '_' + state.mdnNumber + '_' + Math.floor(Math.random() * 99999).toString(),
                callbackURL: '',
                emailAddress: emailAddress,
                accountNumber:accountNumber,
                loginUserName: props.loginUserName
            };
            setIsLoading(true)
            PostDataAPI("telispire/changeLineVMPassword", obj,true).then((result) => {
                setIsLoading(false)
                if (result.success && result.data != null) {
                    handleSuccessClose("Voicemail password successfully updated.");
                } else {
                    showMessage("Error", result.message, "error", 3000);
                    console.log(result.message);
                }
            })
        }
        
    }
    useEffect(() => {
        console.log(props)
    }, []);
    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableEscapeKeyDown
            open={dialogOpenClose}
            maxWidth="lg"
            PaperComponent={!window.isIpadView ? DraggableComponent : undefined}
            {...props} >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>Change Voicemail Password</Typography>
                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                    </div>
                   
                    {isLoading ? <DialogLoader></DialogLoader> : ''}
                    <div className={classes.content}>
                        <Scrollbars autoHeight autoHeightMin={150} autoHeightMax={600}>
                       
                            <Grid container direction="column">
                          
                                <Label size={12} title="Phone Number" mandatory={true} />
                                <Grid item lg={12}>
                                    <InputBaseField
                                        id="mdnNumber"
                                        name="mdnNumber"
                                        value={state.mdnNumber}
                                        type="text"
                                        onChange={handlePhoneChange}
                                        placeholder='Phone number'
                                        IsDisabled={fromDashboard ? false : true}
                                        MaxLength={14}
                                    />
                                    {errorMessages.errorPhone && !state.mdnNumber ? (<FormHelperText style={{ color: "red" }} >
                                        Please enter number
                                    </FormHelperText>) : ('')}
                                    {errorMessages.errorInvalidPhone && state.mdnNumber && !validatePhoneNumber(state.mdnNumber) ? (<FormHelperText style={{ color: "red" }} >
                                        Please enter valid phone number
                                    </FormHelperText>) : ('')}
                                </Grid>
                                <Grid item lg={12}>
                                      <Label size={12} title="New Password" mandatory={true} />
                                </Grid>
                            
                                <Grid item lg={12}>
                                    <InputBaseField
                                        id="newPassword"
                                        name="newPassword"
                                        type="text"
                                        value={state.newPassword}
                                        placeholder='Enter New Password'
                                        onChange={handleChange}
                                        IsDisabled={false}
                                        MaxLength="4"
                                        onKeyPress={(e) => handleNumberKeyPress(e)}
                                    />
                                    {errorMessages.errorNewPassword && !state.newPassword ? (<FormHelperText style={{ color: "red" }} >
                                        Please enter new password
                                    </FormHelperText>) : ('')}

                                    {errorMessages.errorInvalidNewPassword && state.newPassword && !passwordPattern.test(state.newPassword) ? (<FormHelperText style={{ color: "red" }} >
                                        Please must be numeric
                                    </FormHelperText>) : ('')}

                                    
                                   
                                </Grid>
                            </Grid>
                        </Scrollbars>
                    </div>
                    <div className={classes.footer}>

                        <div className={classes.footerRight}>

                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            {isLoading ?
                                <Button className={classes.changeBtn}>Submit</Button>
                                :
                                <Button className={classes.changeBtn} onClick={changeVMPassword}
                                >Submit</Button>
                            }
                           

                        </div>
                    </div>
                </div>
            </div>
        </Dialog >
    )
}

export default withSnackbar(ChangeVMPassword);